import { IFaqSection } from 'shared/types/faq';
import * as styles from './styles.css';
import { Accordion, ModalWindow, TDeviceType } from '@cian/ui-kit';
import { FaqItem } from './components/FaqItem';
import { clsx } from 'clsx';

interface IFaqProps {
  device: TDeviceType;
  faq: IFaqSection[];
  activeFaq: IFaqSection;
  handleActiveFaq: (faq: IFaqSection) => void;
  modalVisible: boolean;
  toggleModalVisible: () => void;
}

export const Faq: React.FC<IFaqProps> = ({
  device,
  faq,
  activeFaq,
  handleActiveFaq,
  modalVisible,
  toggleModalVisible,
}) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Ответы на вопросы</div>
      <div className={styles['blocks']}>
        {faq.map((item, index) => (
          <div key={index} className={styles['block']} onClick={() => handleActiveFaq(item)}>
            <div className={styles['block-title']}>{item.title}</div>
            <div className={styles['custom-btn']} />
          </div>
        ))}
      </div>
      <ModalWindow
        content={
          <div className={clsx(styles['modal-container'], styles[device])}>
            <div className={styles['modal-title']}>{activeFaq.title}</div>
            <Accordion
              size={device === 'phone' ? 'S' : 'M'}
              items={activeFaq.faq.map(item => ({
                title: item.title,
                content: <FaqItem device={device} content={item.content} />,
              }))}
            />
          </div>
        }
        open={modalVisible}
        onClose={toggleModalVisible}
      />
    </div>
  );
};
